import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hides the app-shell splash (markup + styles in public/index.html) once
// React has actually painted its first frame. A double
// requestAnimationFrame waits for the paint that follows this render's
// commit — a blind setTimeout could fire either too early (still blank
// underneath) or add an unnecessary extra delay once content is already
// there; this ties the hide to the real render lifecycle instead of a
// guessed duration.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const splash = document.getElementById("app-splash");
    if (splash) splash.classList.add("app-splash-hide");
  });
});
